<template>
  <!-- 已归档案件：5 -->
  <div id="join">
    <CommitVue :mystatus="mystatus" ref="childComponent"></CommitVue>
  </div>
</template>
  
  <script>
import CommitVue from './Commit.vue'
import { getMyCaseApi } from '../../api/case'
// import List from "../../components/case/List.vue";
// import { resumeMixin } from "../../mixins/resumeMixin";

// import { getMyCreateResumeApi111,postMyCreateResumeApi111 } from '../../tools/rapi'
export default {
  name: 'filedCase',
  // mixins: [],
  data() {
    return {
      mystatus: 5,
      list: [],
      loading: true,
      next:false,
    }
  },
  mounted() {
    // let publicParams = this.$publicParams({
    //   token: sessionStorage.getItem("token"),
    // });
    // getMyCreateResumeApi(publicParams).then((res) => {
    //   if (res.data.status === 200) {
    //       // console.log("ooooo ",res);
    //     this.list = res.data.data.records;
    //     this.loading = false;
    //   }
    // });
  },
  components: {
    CommitVue
  },
  methods: {
    getvalue() {//传值给父组件，
      this.$emit('value', this.next)
    },
  },
  created(){
    this.getvalue()
  },
  beforeRouteLeave(to, from, next) {
        const type = 'CasePage'+this.mystatus;
        if(to.name=='bankruptdetail'||to.name=='caseinfo'||to.name=='bankinput'){
          this.$refs.childComponent.saveSearchCondition()
        }else{
          this.$refs.childComponent.clearSearchConditions()
        }
       
        next();
    },
    beforeRouteEnter(to, from, next) {
      // 通过 next 回调访问组件实例
      next(vm => {

        vm.$refs.childComponent.hqSearchConditions(from.name)
              
          });
        
    },
}
</script>
  
  <style lang="less" scoped>
#join {
  h3 {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: bold;
  }
}
</style>
  